import { schema } from 'normalizr';
import accountSchema from './accountSchema';

const campaignSchema = new schema.Entity('campaigns', {
  account: accountSchema,
});

export default campaignSchema;
